module.exports = __webpack_public_path__ + "img/u652b.66051a8a.jpg";